import { render, staticRenderFns } from "./update-material-modal.vue?vue&type=template&id=2aab9f21&scoped=true"
import script from "./update-material-modal.vue?vue&type=script&lang=js"
export * from "./update-material-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab9f21",
  null
  
)

export default component.exports